import { keyframes } from 'styled-components';

/**
 * Using any here because there is an issue with reference
 * because some internals are not exported and it's too painful
 * to deal with with 0 benefits
 * https://typescript.tv/errors/#ts4023
 */
export const fadeIn: any = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const fadeOut: any = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
